import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: "replaceLine" })
export class ReplaceLinePipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string): string {
      console.log(value)
    if (value && value!!) {
      return value.replace(/\n/g, "<br/>");
    } else {
      return "";
    }
  }
}
